<template>
  <div>
    <!-- 搜索区域 -->
    <!-- <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">单位名称：</div>
        <el-input
          placeholder="请输入单位名称"
          size="medium"
          v-model="queryInfo"
          @change="getCollectionList()"
          clearable
        >
        </el-input>
      </div>
    </div> -->

    <!-- 卡片框 -->
    <div class="bottom-bigbox">
      <!-- 左边单位卡片区域 -->
      <div class="leftBox">
        <!-- 单位树 -->

        <el-tree
          class="treeBox"
          :data="depTrees"
          :props="defaultTreesProps"
          default-expand-all
          :expand-on-click-node="false"
          :highlight-current="true"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <!-- 右边采集站卡片区域 -->
      <el-col :span="20">
        <el-card class="right-card">
          <!-- 增加采集站按钮 -->
          <el-button
            icon="el-icon-plus"
            type="primary"
            size="small"
            class="add-btn"
            plain
            @click="AddCollectionDialogVisible = true"
          >
            新增采集站
          </el-button>
          <!-- 修改采集站按钮 -->
          <el-button
            icon="el-icon-setting"
            type="warning"
            size="small"
            class="add-btn"
            plain
            @click="openUpdateCollection()"
          >
            修改采集站
          </el-button>
          <!-- 重启采集站按钮 -->
          <el-button
            icon="el-icon-refresh-left"
            type="warning"
            size="small"
            class="add-btn"
            plain
            @click="restartCollection()"
          >
            重启采集站
          </el-button>
          <!-- 关机采集站按钮 -->
          <el-button
            icon="el-icon-switch-button"
            type="warning"
            size="small"
            class="add-btn"
            plain
            @click="closeCollection()"
          >
            关机采集站
          </el-button>
          <!-- 删除采集站按钮 -->
          <el-button
            icon="el-icon-delete"
            type="danger"
            size="small"
            class="add-btn"
            plain
            @click="deleteCollectionByid()"
          >
            删除采集站
          </el-button>
          <!-- 刷新采集站按钮 -->
          <el-button
            icon="el-icon-refresh"
            type="success"
            size="small"
            class="add-btn"
            plain
            @click="refreshCollectionList()"
          >
            刷新
          </el-button>

          <!-- 采集站信息表格区域 -->
          <ul class="collection-bigBox">
            <li
              v-for="item in this.collectionList"
              :key="item.collectionId"
              class="collection-smallBox"
              :class="
                activeCollect == item.collectionId
                  ? 'collection-smallBox-active'
                  : ''
              "
              @click="onclickCollection(item)"
            >
              <img
                v-show="item.isOnLine == true"
                src="../../../assets/img/collection/online.png"
                alt=""
              />
              <img
                v-show="item.isOnLine == false"
                src="../../../assets/img/collection/outline.png"
                alt=""
              />
              <div class="smallBox-right">
                <div>站点名称：{{ item.collectionName }}</div>
                <div>
                  在线状态：{{ item.isOnLine == true ? "在线" : "离线" }}
                </div>
                <div>所属项目：{{ item.collectionDepName }}</div>
                <div>
                  上传状态：{{
                    item.collectionUploadPolicy == 0
                      ? "不上传"
                      : item.collectionUploadPolicy == 1
                      ? "上传所有"
                      : "上传重点"
                  }}
                </div>
                <div v-if="item.isOnLine">
                  磁盘剩余：
                  {{ (item.free / (1024 * 1024 * 1024)).toFixed(1) + "GB" }}
                </div>
                <div v-if="item.isOnLine">
                  磁盘总量：
                  {{ (item.total / (1024 * 1024 * 1024)).toFixed(1) + "GB" }}
                </div>

                <div>
                  密钥:<span class="collectionKey">{{
                    item.collectionKey
                  }}</span>
                </div>
              </div>
            </li>
          </ul>
          <!-- 分页 -->
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryInfo.page"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </el-card>
      </el-col>
    </div>

    <!-- 添加采集站信息对话框 -->
    <el-dialog
      title="新增采集站"
      :visible.sync="AddCollectionDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddCollectionDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addCollectionFormRef"
        :rules="AddCollectionRules"
        :model="CollectionInfo"
        label-width="80px"
      >
        <el-form-item prop="collectionName" label="站点名称">
          <el-input
            placeholder="请输入站点名称"
            v-model="CollectionInfo.collectionName"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="collectionDepId" label="所属项目">
          <el-select
            v-model="CollectionInfo.collectionDepId"
            placeholder="请选择"
            ref="MySelect"
          >
            <el-option
              :key="CollectionInfo.collectionDepId"
              :label="checkDname"
              :value="CollectionInfo.collectionDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleNodeClick2"
            >
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item label="上传类型" prop="collectionUploadPolicy">
          <el-radio-group v-model="CollectionInfo.collectionUploadPolicy">
            <el-radio :label="0">不上传</el-radio>
            <el-radio :label="1">上传所有</el-radio>
            <el-radio :label="2">上传重点</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddCollectionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="AddCollection()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改采集站信息对话框 -->
    <el-dialog
      title="修改采集站信息"
      :visible.sync="UpdateCollectionDialog"
      width="50%"
      :close-on-click-modal="false"
      @close="clearUpdateDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="updateCollectionFormRef"
        :rules="AddCollectionRules"
        :model="UpdateInfo"
        label-width="80px"
      >
        <el-form-item prop="collectionName" label="站点名称">
          <el-input
            placeholder="请输入站点名称"
            v-model="UpdateInfo.collectionName"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="collectionDepId" label="所属项目">
          <el-select
            v-model="UpdateInfo.collectionDepId"
            placeholder="请选择"
            ref="MyUpdateSelect"
          >
            <el-option
              :key="UpdateInfo.collectionDepId"
              :label="UpdateInfo.collectionDepName"
              :value="UpdateInfo.collectionDepId"
              style="height: auto"
            >
            </el-option>
            <el-tree
              style="height: 300px"
              :data="depTrees"
              :props="defaultTreesProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              @node-click="handleUpdateDepNodeClick"
            >
            </el-tree>
          </el-select>
        </el-form-item>
        <el-form-item label="上传类型" prop="collectionUploadPolicy">
          <el-radio-group v-model="UpdateInfo.collectionUploadPolicy">
            <el-radio :label="0">不上传</el-radio>
            <el-radio :label="1">上传所有</el-radio>
            <el-radio :label="2">上传重点</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="UpdateCollectionDialog = false">取 消</el-button>
        <el-button type="primary" @click="Update()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      //采集站列表信息
      collectionList: [],
      // 采集站列表查询信息
      queryInfo: {
        // 单位id
        depId: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },
      // 点击后的单个采集站信息
      collectionInfo: {},
      // 当前选中采集站
      activeCollect: -1,
      //  单位总数量
      total: 0,
      // 单位树信息
      depTrees: [],
      defaultTreesProps: {
        children: "depChilds",
        label: "depName",
      },
      // 控制增加采集站对话框的显示和隐藏
      AddCollectionDialogVisible: false,
      // 采集站实体
      CollectionInfo: {
        // 采集站名称
        collectionName: "",
        // 所属单位
        collectionDepId: "",
        // 文件上传类型
        collectionUploadPolicy: "",
      },
      // 增加单位选中单位名称
      checkDname: "",
      // 控制修改对话框的显示和隐藏
      UpdateCollectionDialog: false,
      // 修改采集站实体
      UpdateInfo: {
        // 采集站ID
        collectionId: "",
        // 采集站名称
        collectionName: "",
        // 所属单位ID
        collectionDepId: "",
        // 所属单位名称
        collectionDepName: "",
        // 上传类型
        collectionUploadPolicy: "",
      },
      //增加采集站规则校验
      AddCollectionRules: {
        collectionName: [
          { required: true, message: "请输入采集站名称", trigger: "blur" },
        ],
        collectionDepId: [
          { required: true, message: "请选择所属项目", trigger: "change" },
        ],
        collectionUploadPolicy: [
          { required: true, message: "请选择上传类型", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.getCollectionList();
    this.GetAllDepTrees();
  },
  mounted() {},
  methods: {
    // 查询采集站列表信息
    async getCollectionList() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/collection/search`,
        {
          params: this.queryInfo,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.collectionList = res.data.rows;
      // 采集站总数量
      this.total = res.data.total;
    },
    // 刷新采集站列表
    refreshCollectionList() {
      this.getCollectionList();
      this.collectionInfo = {};
      this.activeCollect = -1;
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryInfo.pageSize = size;
      this.getCollectionList();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryInfo.page = current;
      this.getCollectionList();
    },

    // 获取全部单位树
    async GetAllDepTrees() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/department/getDepTree`
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.depTrees = res.data;
    },
    handleNodeClick(data) {
      this.queryInfo.depId = data.depId;
      this.getCollectionList();
    },
    // 当选中单位时触发
    handleNodeClick2(data) {
      this.CollectionInfo.collectionDepId = data.depId;
      this.checkDname = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MySelect.handleClose();
    },
    // 增加采集站
    AddCollection() {
      this.$refs.addCollectionFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/collection/add`,
          this.CollectionInfo
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("新增采集站成功");
        this.AddCollectionDialogVisible = false;
        this.getCollectionList();
      });
    },
    //关闭增加采集站信息
    clearAddCollectionDialogVisible() {
      this.checkDname = "";
      this.$refs.addCollectionFormRef.resetFields();
    },
    // 点击采集站执行
    onclickCollection(collectionInfo) {
      this.activeCollect = collectionInfo.collectionId;
      this.collectionInfo = collectionInfo;
    },
    //打开修改采集站信息对话框
    openUpdateCollection() {
      // 判断是否选中其中一个采集站
      if (
        JSON.stringify(this.collectionInfo) === "{}"
        // Object.keys(this.collectionInfo).length === 0
      ) {
        this.$message.warning("请先选中一个采集站后再修改!");
        return;
      }
      this.UpdateCollectionDialog = true;
      // 本采集站站点名称
      this.UpdateInfo.collectionName = this.collectionInfo.collectionName;
      // 采集站ID
      this.UpdateInfo.collectionId = this.collectionInfo.collectionId;
      // 所属单位ID
      this.UpdateInfo.collectionDepId = this.collectionInfo.collectionDepId;
      // 所属单位名称
      this.UpdateInfo.collectionDepName = this.collectionInfo.collectionDepName;
      // 上传状态
      this.UpdateInfo.collectionUploadPolicy =this.collectionInfo.collectionUploadPolicy;
    },
    // 当选中单位时触发
    handleUpdateDepNodeClick(data) {
      console.log(data);
      // 选中后的所属单位ID
      this.UpdateInfo.collectionDepId = data.depId;
      //选中后的父单位名称
      this.UpdateInfo.collectionDepName = data.depName;
      // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      this.$refs.MyUpdateSelect.handleClose();
    },

    // 修改采集站信息
    async Update() {
      const { data: res } = await this.$axios.put(
        `${this.$api}/collection/modfiy/${this.UpdateInfo.collectionId}`,
        {
          collectionName: this.UpdateInfo.collectionName,
          collectionDepId: this.UpdateInfo.collectionDepId,
          collectionUploadPolicy: this.UpdateInfo.collectionUploadPolicy,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success("修改采集站信息成功");
      this.getCollectionList();
      this.UpdateCollectionDialog = false;
    },

    //关闭修改采集站信息对话框
    clearUpdateDialogVisible() {
      this.$refs.updateCollectionFormRef.resetFields();
    },
    // 重启采集站
    async restartCollection() {
      // 判断是否选中其中一个采集站
      if (
        JSON.stringify(this.collectionInfo) === "{}"
        // Object.keys(this.collectionInfo).length === 0
      ) {
        this.$message.warning("请先选中一个采集站后再重启!");
        return;
      } else if (this.collectionInfo.isOnLine == false) {
        this.$message.warning("请先选中一个在线的采集站后再重启!");
        return;
      }
      const confirmVal = await this.$confirm(
        "此操作将重启该采集站, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消重启");
      }
      const { data: res } = await this.$axios.get(
        `${this.$api}/collection/command`,
        {
          params: {
            collectionKey: this.collectionInfo.collectionKey,
            command: "reboot",
          },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("采集站重启成功");
      this.getCollectionList();
    },
    // 采集站关机
    async closeCollection(key) {
      // 判断是否选中其中一个采集站
      if (
        JSON.stringify(this.collectionInfo) === "{}"
        // Object.keys(this.collectionInfo).length === 0
      ) {
        this.$message.warning("请先选中一个采集站后再关机!");
        return;
      }
      // 采集站在线才能操作
      else if (this.collectionInfo.isOnLine == false) {
        this.$message.warning("请先选中一个在线的采集站后再关机!");
        return;
      }
      const confirmVal = await this.$confirm(
        "此操作将关机该采集站, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消关机");
      }
      const { data: res } = await this.$axios.get(
        `${this.$api}/collection/command`,
        {
          params: {
            collectionKey: this.collectionInfo.collectionKey,
            command: "shutdown",
          },
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("采集站关机成功");
      this.getCollectionList();
    },
    // 删除采集站
    async deleteCollectionByid() {
      // 判断是否选中其中一个采集站
      if (
        JSON.stringify(this.collectionInfo) === "{}"
        // Object.keys(this.collectionInfo).length === 0
      ) {
        this.$message.warning("请先选中一个采集站后再删除!");
        return;
      }
      const confirmVal = await this.$confirm(
        "此操作将永久删除该采集站, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/collection/delete/` + this.collectionInfo.collectionId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryInfo.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryInfo.page === lastPage &&
        this.total % this.queryInfo.pageSize === 1
      ) {
        this.queryInfo.page--; //页码-1
      }

      this.$message.success("采集站删除成功");
      this.getCollectionList();
    },
  },
};
</script>                                                                                                                                                                                                 n 

<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.el-card__body {
  overflow-x: auto !important;
}

/* 搜索区域 */
.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}

/*下面内容区域大盒子*/
.bottom-bigbox {
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* 左边单位列表 */
.leftBox {
  width: 300px;
  height: calc(100vh - 159px);
  /* background-color: #001114; */
  background-image: url(../../../assets/img/dataBoard/box2.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  opacity: 0.8;
  /* position: absolute; */
  /* left: 0; */
  display: flex;
  z-index: 999;
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 300px;
  margin: 40px 10px 20px 10px;
  height: calc(100vh - 220px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
}

// 右边采集站信息大盒子
.collection-bigBox {
  width: 100%;
  max-height: calc(100vh - 300px);
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
  padding: 0;
  // justify-content: space-around;
}

// 单个采集站信息小盒子
.collection-smallBox {
  border: 1px dotted #0693c0;
  background-color: #065e86;
  margin: 10px;
  width: 330px;
  height: 200px;
  display: flex;
}

// 选中采集站小盒子样式
.collection-smallBox-active {
  cursor: pointer;
  background-color: #3f30af45;
  border: 1px solid #0693c0;
  margin: 10px;
  width: 330px;
  height: 200px;
  display: flex;
}

// .collection-smallBox:hover {
//   cursor: pointer;
//   background-color: #3f30af45;
//   border: 1px solid #0693c0;
// }

.smallBox-right {
  height: 100%;

  color: #06aae0;
  margin: 0 10px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  div {
    width: 100%;
  }
}

// 密钥可以复制
.collectionKey {
  -moz-user-select: all; /*火狐*/

  -webkit-user-select: all; /*webkit浏览器*/

  -ms-user-select: all; /*IE10*/

  -khtml-user-select: all; /*早期浏览器*/

  user-select: all;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/ServerManager/collectionConfig.vue